import React from 'react';
import {Col, Row} from 'react-bootstrap';
import {Link} from 'react-router-dom';

import BizStepSelector from '../component/BizStep/BizStepSelector';
import DispositionSelector from '../disposition/DispositionSelector';
import ProductTypeSelector from '../productType/component/ProductTypeSelector'
import BalanceService from "./BalanceService";
import CompanyConfigurationService from "../services/CompanyConfiguration";
import {BalanceStorage} from "./BalanceStorage";
import BizLocationSelector from "../component/BizLocation/BizLocationSelector";

export default class BalanceByProductTypeGrid {

  title = "Saldo atual por Tipo de Produto";

  showNewButton = false;
  exportNewPage = true;
  balanceStorage = new BalanceStorage();
  customFilters = {
    dispositionId: this.balanceStorage.getDispositions(),
    bizStepId: this.balanceStorage.getBizSteps(),
    productTypeId: this.balanceStorage.getProductTypes(),
    bizLocationId: this.balanceStorage.getBizLocation()
  }
  productTypeStorage (id){
    this.balanceStorage.saveProductTypeDateByAsset(id)
  }

  getColumns = (props, state) => {
    const columns = [
      {
        Header: "Referência",
        accessor: "reference",
        Cell: props => {
          const {id, reference} = props.original;
          const {bizLocationId, bizStepId, dispositionId} = this.customFilters

          const url = `/list/balance-by-assets/biz-locations/${bizLocationId}/product-types/${id}`;
          const query = `${url}?bizStepId=${bizStepId}&dispositionId=${dispositionId}`;

          return (
            <Link to={query} query={{d: 1}} params={{e: 2}} onClick={() => this.productTypeStorage(id)}>
              {reference}
            </Link>);
        }
      },
      {
        Header: "Nome",
        accessor: "friendlyName"
      },
      {
        Header: "Total de produtos",
        accessor: "totalAssets"
      },
    ];

    if (new CompanyConfigurationService().canShowWeight()) {
      columns.push(
        {
          Header: "Peso total",
          accessor: "weightInKg",
          Cell: row => row.original && `${row.original.weightInKg} kg`
        },)
    }
    return columns;
  }

  customFilterComponent = (props, state, onChange) => {
    return (
      <Row>
        <Col md={3}>
          <BizLocationSelector
            multiple
            defaultValue={props.match.params.bizLocationId}
            setValue={value => {
              this.customFilters.bizLocationId = value.map(x => x.id);
              onChange(this.customFilters);
            }}
          />
        </Col>
        <Col md={3}>
          <ProductTypeSelector
            multiple
            defaultValue={this.customFilters.productTypeId}
            setValue={value => {
              this.customFilters.productTypeId = value.map(x => x.id);
              onChange(this.customFilters);
            }}/>
        </Col>
        <Col md={3}>
          <DispositionSelector
            multiple
            defaultValue={this.customFilters.dispositionId}
            setValue={value => {
              this.customFilters.dispositionId = value.map(x => x.id);
              onChange(this.customFilters);
            }}/>
        </Col>
        <Col md={3}>
          <BizStepSelector
            multiple
            defaultValue={this.customFilters.bizStepId}
            setValue={value => {
              this.customFilters.bizStepId = value.map(x => x.id);
              onChange(this.customFilters);
            }}/>
        </Col>
      </Row>
    )
  };

  endpoint = ({match}) => {
    const params = new URLSearchParams({});
    if (!this.customFilters.bizLocationId) {
      this.customFilters.bizLocationId = [match.params.bizLocationId];
    }

    if (this.customFilters.bizLocationId) {
      this.balanceStorage.saveBizLocationData(this.customFilters.bizLocationId)
      this.customFilters.bizLocationId && params.append('bizLocationIds', this.customFilters.bizLocationId);
    }
    if (this.customFilters.dispositionId) {
      this.balanceStorage.saveDispositionData(this.customFilters.dispositionId);
      this.customFilters.dispositionId && params.append('dispositionIds', this.customFilters.dispositionId);
    }
    if (this.customFilters.bizStepId) {
      this.balanceStorage.saveBizStepData(this.customFilters.bizStepId);
      this.customFilters.bizStepId && params.append('bizStepIds', this.customFilters.bizStepId);
    }
    if (this.customFilters.productTypeId) {
      this.balanceStorage.saveProductTypeDate(this.customFilters.productTypeId);
      this.customFilters.productTypeId && params.append('productTypeIds', this.customFilters.productTypeId);
    }

    return `${BalanceService.PRODUCT_TYPE_URL}?${params.toString()}`
    }
  }



// WEBPACK FOOTER //
// ./src/balance/BalanceByProductTypeGrid.js